import { useNavigate } from "react-router-dom";
import { componentRoutes } from "../routes/routes";
import icLogo from "../assests/images/logo.svg";
import {
  getUser,
  isCaregiver,
} from "../userStore";
import { useEffect, useState } from "react";
import { useGetNotificationsQuery } from "../redux/service/notifications_service";

export const AppNavigation = ({ availableRoutes }) => {
  const navigateTo = useNavigate();
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const isActiveLink = (path) => {
    return window.location.href.includes(path);
  };

  const { data, refetch, isLoading } = useGetNotificationsQuery({
    status: "all",
    type: "patient",
  });

  const [countNotification, setCountNotification] = useState([]);
  useEffect(() => {
    if (data?.data?.length > 0)
      setCountNotification(data?.data?.filter((v) => v.Alert.unread == 1));
  }, [data?.data]);

  const getPatientName = () => {
    const patient = getUser();
    if (patient?.full_name) {
      return patient?.full_name;
    }
    if (patient?.fname) {
      return patient?.fname + " " + (patient?.lname || "");
    }
  };

  const filterNavLinks = (r) => {
    return (
      (availableRoutes.includes("all") || availableRoutes.includes(r.slug)) &&
      r.nav !== false
    );
  };

  const toggleSidebar = () => {
    setShowMobileSidebar(!showMobileSidebar);
  };

  return (
    <>
      {/* Mobile hamburger menu button */}
      <div className="lg:hidden fixed top-4 left-1 z-50">
        <button
          type="button"
          className="p-2 rounded-md text-white"
          onClick={toggleSidebar}>
          <svg
            className="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>
      <div
        className={`lg:hidden fixed inset-0 z-40 ${
          showMobileSidebar ? "block" : "hidden"
        }`}>
        <div className="fixed inset-0 bg-gray-900/80"></div>
        <div className="fixed inset-0 flex">
          <div className="relative mr-16 flex w-full max-w-xs flex-1">
            <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
              <button
                type="button"
                className="-m-2.5 p-2.5"
                onClick={toggleSidebar}>
                <span className="sr-only">Close sidebar</span>
                <svg
                  className="h-6 w-6 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  aria-hidden="true">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white  px-6 pb-4">
              <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white pb-4">
                <div className="flex shrink-0 items-center sticky px-6 py-3 top-0 bg-white">
                  <img className="w-auto" src={icLogo} alt="ethizo" />
                </div>
                {isCaregiver() == 1 && (
                  <div className="bg-teal-37 pt-1 pb-3 px-5 text-start">
                    <h3 className="text-white">
                      Logged In As: <strong>{getPatientName()}</strong>{" "}
                    </h3>
                    <button
                      onClick={() => navigateTo("/patients")}
                      className="rounded bg-white px-2 py-1 mt-2 flex gap-2 items-center text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        className="w-4 h-4">
                        <path d="M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z" />
                      </svg>
                      Switch User
                    </button>
                  </div>
                )}
                <nav className="flex flex-1 flex-col px-6">
                  <ul role="list" className="flex flex-1 flex-col gap-y-7">
                    <li>
                      <ul role="list" className="-mx-2 space-y-1">
                        {componentRoutes
                          ?.filter((r) => filterNavLinks(r))
                          .map((r, rIndex) => {
                            return (
                                <li key={r.slug || rIndex}>
                                  <a
                                    href="#"
                                    onClick={() => navigateTo(r.path)}
                                    className={`${
                                      isActiveLink(r.path)
                                        ? "bg-blue-600 text-white"
                                        : "bg-white text-gray-600"
                                    } group flex items-center gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold hover:bg-blue-600 hover:text-white`}>
                                    <span
                                      className={`shrink-0 p-1.5 rounded-full ${
                                        !isActiveLink(r.path) &&
                                        r?.nonActiveClass
                                      }`}>
                                      <r.icon className="h-5 w-5" />
                                    </span>
                                    {r.title}
                                    {r.slug == "notifications" &&
                                      ` (${
                                        countNotification?.length > 0
                                          ? countNotification?.length
                                          : 0
                                      })`}
                                  </a>
                                </li>
                            );
                          })}
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden lg:fixed lg:top-0 lg:bottom-[48px] lg:z-3 lg:flex lg:w-72 lg:flex-col">
        <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white pb-4">
          <div className="flex shrink-0 items-center sticky px-6 py-3 top-0 bg-white">
            <img className="w-auto" src={icLogo} alt="ethizo" />
          </div>
          {isCaregiver() == 1 && (
            <div className="bg-teal-37 pt-1 pb-3 px-5 text-start">
              <h3 className="text-white">
                Logged In As: <strong>{getPatientName()}</strong>{" "}
              </h3>
              <button
                onClick={() => navigateTo("/patients")}
                className="rounded bg-white px-2 py-1 mt-2 flex gap-2 items-center text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className="w-4 h-4">
                  <path d="M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z" />
                </svg>
                Switch User
              </button>
            </div>
          )}
          <nav className="flex flex-1 flex-col px-6">
            <ul role="list" className="flex flex-1 flex-col gap-y-7">
              <li>
                <ul role="list" className="-mx-2 space-y-1">
                  {componentRoutes
                    ?.filter((r) => filterNavLinks(r))
                    .map((r, rIndex) => {
                      return (
                          <li key={r.slug || rIndex}>
                            <a
                              href="#"
                              onClick={() => navigateTo(r.path)}
                              className={`${
                                isActiveLink(r.path)
                                  ? "bg-blue-600 text-white"
                                  : "bg-white text-gray-600"
                              } group flex items-center gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold hover:bg-blue-600 hover:text-white`}>
                              <span
                                className={`shrink-0 p-1.5 rounded-full ${
                                  !isActiveLink(r.path) && r?.nonActiveClass
                                }`}>
                                <r.icon className="h-5 w-5" />
                              </span>
                              {r.title}
                              {r.slug == "notifications" &&
                                ` (${
                                  countNotification?.length > 0
                                    ? countNotification?.length
                                    : 0
                                })`}
                            </a>
                          </li>
                      );
                    })}
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      {/* <ul> 
        {
          componentRoutes.filter(r => r.nav !== false).map( r => <li onClick={() => navigateTo(r.path)}>{r.title}</li>)
        }
      </ul> */}
    </>
  );
};
